import PoziadavkaService from "../../poziadavky/PoziadavkaService";
import PoziadavkaCtrl from "../../poziadavky/PoziadavkaBaseCtrl";
import PoziadavkaListCtrl from "../../poziadavky/PoziadavkaListCtrl";
import PoziadavkaEditCtrl from "../../poziadavky/PoziadavkaEditCtrl";
import PoznamkaEditModalCtrl from "./PoznamkaEditModalCtrl";
import PoziadavkaChangeStateModalCtrl from "../../poziadavky/PoziadavkaChangeStateModalCtrl";

export default angular.module("antes.poziadavky", [])
.config(function routes($stateProvider){
  $stateProvider
  .state("poziadavka", {
    url: "/poziadavka/{id:int}",
    template: require("./poziadavka.html"),
    controller: PoziadavkaCtrl,
    controllerAs: "ctrl"
  })
  .state("poziadavky", {
    url: "/poziadavky?filter",
    template: require("./poziadavka.list.html"),
    controller: PoziadavkaListCtrl,
    controllerAs: "ctrl",
    resolve:{
      ZakaznikService: () => false,
      typy: PoziadavkaListCtrl.resolve.typy
    }
  })
  .state("poziadavka-edit", {
    url: "/poziadavka/{id:int}/edit?typ",
    template: require("./poziadavka.edit.html"),
    controller: PoziadavkaEditCtrl,
    controllerAs: "ctrl",
    resolve: {
      uzivatelia: () => [],
      osoby: () => [],
      zakaznici: () => [],
      typy: PoziadavkaEditCtrl.resolve.typy,
      ProjektService: () => false,
      pobockaProvider: ($q) => () => $q.resolve([]),
      osobaProvider: ($q) => () => $q.resolve([]),
      projektProvider: ($q) => () => $q.resolve([]),
    }
  })
})
.service("PoziadavkaService", PoziadavkaService)
.controller("PoznamkaEditModalCtrl", PoznamkaEditModalCtrl)
.controller("PoziadavkaChangeStateModalCtrl", PoziadavkaChangeStateModalCtrl)
.factory("PoznamkaEditModal", function($uibModal){
  return function(poziadavka){
    return $uibModal.open({
      template: require("./Poznamka.edit.modal.html"),
      controller: "PoznamkaEditModalCtrl",
      controllerAs: "ctrl",
      resolve: {
        poziadavka: poziadavka,
        uzivatelia: () => []
      }
    });
  };
})
.factory("PoziadavkaCloseModal", function($uibModal){
  return function(poziadavka){
    return $uibModal.open({
      template: require("../../poziadavky/poziadavka.close.modal.html"),
      controller: "PoziadavkaChangeStateModalCtrl",
      controllerAs: "ctrl",
      resolve: {
        poziadavka: poziadavka
      }
    });
  };
})
.factory("PoziadavkaReopenModal", function($uibModal){
  return function(poziadavka){
    return $uibModal.open({
      template: require("../../poziadavky/poziadavka.reopen.modal.html"),
      controller: "PoziadavkaChangeStateModalCtrl",
      controllerAs: "ctrl",
      resolve: {
        poziadavka: poziadavka
      }
    });
  };
})
.name;



// WEBPACK FOOTER //
// ./src/customer-portal/poziadavky/index.js